import React, { useEffect, useRef, useState } from "react";
import { AirbudsYearlyHeader } from "../component/storyHeader";
import { TypeAnimation } from "react-type-animation";

import { useNavigate } from "react-router";

import { motion, animate } from "motion/react";
import ShareableComponent from "../sharing";
import { randomNumber } from "../stats/statsIntro";
import EmojiWave from "../compat/emojiWave";
import { StoryOverlay } from "../compat/compat";
import StoryProgressBar from "../component/pagination";

function useStateAndRef(initial) {
  const [value, setValue] = useState(initial);
  const valueRef = useRef(value);
  valueRef.current = value;
  return [value, setValue, valueRef];
}

export const ThanksUsersBackground = ({ data }) => {
  const floatingAnimation = {
    x: [0, randomNumber(4, 12), 0],
    y: [0, randomNumber(5, 9), 0], // Move up by 20px, then back to original
    transition: {
      duration: 10, // Duration of one cycle
      ease: "easeInOut",
      repeat: Infinity, // Loop indefinitely
    },
    exit: {
      y: "-150%",
    },
  };

  const floatingAnimation2 = {
    x: [randomNumber(6, 15), 0, randomNumber(6, 15), 0],
    y: [randomNumber(0, 9), 0, randomNumber(0, 9), 0], // Move up by 20px, then back to original
    transition: {
      duration: 10, // Duration of one cycle
      ease: "easeInOut",
      repeat: Infinity, // Loop indefinitely
    },
    exit: {
      y: "-150%",
    },
  };

  return (
    <motion.div
      className="track-played-background"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      exit={{ scale: 0 }}
      transition={{
        duration: 1.0,
        delay: 2.5,
        ease: [0, 0.71, 0.2, 1.01],
      }}
    >
      <div className="user-played-images">
        <motion.img
          className="user-background cover-background--small"
          src={require("../assets/img/avatars/avatar1.png")}
          alt="Small Circle"
        />
        <motion.img
          className="user-background cover-background--medium"
          src={require("../assets/img/avatars/avatar2.png")}
          alt="Medium Circle"
        />
        <motion.img
          className="user-background cover-background--tiny"
          src={require("../assets/img/avatars/avatar3.png")}
          alt="Tiny Circle"
        />
        <motion.img
          className="user-background cover-background--large"
          src={require("../assets/img/avatars/avatar4.png")}
          alt="Large Circle"
        />
        <motion.img
          className="user-background cover-background--xl"
          src={require("../assets/img/avatars/avatar5.png")}
          alt="XL Circle"
        />
        <motion.img
          className="user-background cover-background--mediumAlt"
          src={require("../assets/img/avatars/avatar6.png")}
          alt="Medium Alternate Circle"
        />
        <motion.img
          className="user-background cover-background--mediumAlt2"
          src={require("../assets/img/avatars/avatar7.png")}
          alt="Medium Alternate Circle"
        />
        <motion.img
          className="user-background cover-background--mediumAlt3"
          src={require("../assets/img/avatars/avatar8.png")}
          alt="Medium Alternate Circle"
        />

        <motion.img
          className="floating-badge"
          src={require("../assets/img/shape-stats-4.svg")}
        />
      </div>
    </motion.div>
  );
};

export const Thanks = ({ data }) => {
  const [step, setStep, refStep] = useStateAndRef(0);
  const navigate = useNavigate();

  const previous = () => {
    setStep(Math.max(refStep.current - 1, 0));
  };

  const next = () => {
    if (refStep.current == 4) {
      navigate("/menu");
    } else {
      setStep(Math.min(refStep.current + 1, 4));
    }
  };

  const renderState = (state) => {
    switch (state) {
      case 0:
        return (
          <motion.div
            key="step-0"
            className="app-stats-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <TypeAnimation
              className="headline thanks-headline"
              sequence={[
                1000,
                "what",
                400,
                "what a",
                400,
                "what a year",
                400,
                "what a year",
                1000,
              ]}
              style={{ fontSize: "2em" }}
              typeSpeed={620}
            />
          </motion.div>
        );
      case 1:
        return (
          <div>
            <ThanksUsersBackground />

            <motion.div
              key="step-1"
              className="app-thanks-content"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 0, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              <motion.h3
                initial={{ opacity: 0, y: "100%" }}
                animate={{ opacity: 1, y: "0%" }}
                exit={{ opacity: 1, y: "-100%" }}
                transition={{
                  duration: 1.0,
                  delay: 0.0,
                  ease: [0, 0.71, 0.2, 1.01],
                }}
                className="headline-light"
              >
                in 2024 we hit
              </motion.h3>

              <motion.h1
                className="big-headline"
                initial={{ opacity: 0, y: "100%" }}
                animate={{ opacity: 1, y: "0%" }}
                exit={{ opacity: 1, y: "-100%" }}
                transition={{
                  duration: 1.0,
                  delay: 1.5,
                  ease: [0, 0.71, 0.2, 1.01],
                }}
              >
                4 millions airbuddies
              </motion.h1>

              <motion.p
                className="type-text"
                initial={{ opacity: 0, y: "100%" }}
                animate={{ opacity: 1, y: "0%" }}
                exit={{ opacity: 1, y: "-100%" }}
                transition={{
                  duration: 1.0,
                  delay: 2.0,
                  ease: [0, 0.71, 0.2, 1.01],
                }}
              >
                and we are so appreciative of each and every one of you!
              </motion.p>
            </motion.div>
          </div>
        );
      case 2:
        return (
          <motion.div
            key="step-2"
            className="app-thanks-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <motion.h3
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 1, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.0,
                ease: [0, 0.71, 0.2, 1.01],
              }}
              className="headline-light"
            >
              Sharing your music is an authentic way of
            </motion.h3>

            <motion.h1
              className="big-headline"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 1, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              expressing yourself
            </motion.h1>
          </motion.div>
        );

      case 3:
        return (
          <motion.div
            key="step-4"
            className="app-thanks-content"
            initial={{ opacity: 0, y: "100%" }}
            animate={{ opacity: 1, y: "0%" }}
            exit={{ opacity: 0, y: "-100%" }}
            transition={{
              duration: 1.0,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <motion.h1
              className="big-headline"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 1, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.0,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              🫶
            </motion.h1>

            <motion.h3
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 1, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
              }}
              className="light-headline"
            >
              And we hope you continue to do so in 2025 and beyond
            </motion.h3>
          </motion.div>
        );

      case 4:
        return (
          <div>
            <EmojiWave emojis={Array(50).fill("🩷")} />
            <motion.div
              key="step-5"
              className="app-thanks-content"
              initial={{ opacity: 0, y: "100%" }}
              animate={{ opacity: 1, y: "0%" }}
              exit={{ opacity: 0, y: "-100%" }}
              transition={{
                duration: 1.0,
                delay: 0.0,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              <motion.h1
                className="big-headline"
                initial={{ opacity: 0, y: "100%" }}
                animate={{ opacity: 1, y: "0%" }}
                exit={{ opacity: 1, y: "-100%" }}
                transition={{
                  duration: 1.0,
                  delay: 0.0,
                  ease: [0, 0.71, 0.2, 1.01],
                }}
              >
                Thank you for everything
              </motion.h1>
            </motion.div>
          </div>
        );
      default:
        return <div></div>;
    }
  };

  return (
    <div
      className={
        "app-stats-container thanks-gradient-background " +
        (step == 5 ? "share-background" : "")
      }
    >
      {renderState(step)}
      <StoryOverlay
        className={step == 5 ? "not-clickable" : ""}
        prev={previous}
        next={next}
      />
      <AirbudsYearlyHeader />
      <StoryProgressBar
        className="story-bar"
        totalPages={5}
        currentPage={step}
        duration={0}
      />
    </div>
  );
};
